import { Helpers } from '../../helpers';
import { IStimEfficiency } from '../../interfaces/istim-efficiency';
import { ScheduleBuildSetting } from '../schedule-build-setting';

export class StimEfficiencyBase {
  StimEfficiencyId: number;
  Quantity: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScheduleBuildSettings_DefaultStimEfficiency?: Array<ScheduleBuildSetting> | null;

  constructor(item?: IStimEfficiency) {
    if (item) {

      this.StimEfficiencyId = item.StimEfficiencyId;
      this.Quantity = item.Quantity;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScheduleBuildSettings_DefaultStimEfficiency = Helpers.createClassArray(ScheduleBuildSetting, item.ScheduleBuildSettings_DefaultStimEfficiency);
    }
  }
}